import request from '@/utils/request'

// 排行榜
export function fission_index(data) {
  return request({
    url: '/admin/Statis/index',
    method: 'POST',
    data: data || {}
  })
}

// 讲座排行榜
export function edu1_index(data) {
  return request({
    url: '/admin/activity/index',
    method: 'POST',
    data: data || {}
  })
}
// 讲座排行榜 rank
export function edu1_rank(data) {
  return request({
    url: '/admin/activity/rank',
    method: 'POST',
    data: data || {}
  })
}

// 生涯日历
export function shengya_activity_index(data) {
  return request({
    url: '/admin/activity/shengya_activity_index',
    method: 'POST',
    data: data || {}
  })
}
// 生涯日历 -- 保存关键词
export function shengya_activity_save(data) {
  return request({
    url: '/admin/activity/shengya_activity_save',
    method: 'POST',
    data: data || {}
  })
}
// 生涯日历 -- 上传图片
export function shengya_activity_upload_img(data) {
  return request({
    url: '/api/activity/upload_img',
    method: 'POST',
    data: data || {}
  })
}
// 生涯日历 -- 获取海报
export function shengya_activity_poster(data) {
  return request({
    url: '/admin/activity/shengya_activity_poster',
    method: 'POST',
    data: data || {}
  })
}

// 生涯学院 -- 表单获取
export function shengya_lead(data) {
  return request({
    url: '/api/form/shengya_lead',
    method: 'POST',
    data: data || {}
  })
}

// 生涯学院 -- 提交表单
export function shengya_submit(data) {
  return request({
    url: '/api/form/submit',
    method: 'POST',
    data: data || {}
  })
}

// 高校公益
export function exchange(data) {
  return request({
    url: '/api/college/exchange',
    method: 'POST',
    data: data || {}
  })
}

/**
 * ==================线上基础班查询============↓
 */
// 班级列表
export function getClassname(data) {
  return request({
    url: '/api/online/getClassname',
    method: 'POST',
    data: data || {}
  })
}

// 用户信息查询
export function search(data) {
  return request({
    url: '/api/online/search',
    method: 'POST',
    data: data || {}
  })
}
/**
 * ==================官网抢购支付页面============↓
 */
// 微信支付
export function wxpay(data) {
  return request({
    url: '/admin/shengya/wxpay',
    method: 'POST',
    data: data || {}
  })
}

// H5微信支付
export function h5wxpay(data) {
  return request({
    url: '/admin/shengya/h5wxpay',
    method: 'POST',
    data: data || {}
  })
}

// 查询订单
export function orders(data) {
  return request({
    url: '/admin/shengya/orders',
    method: 'POST',
    data: data || {}
  })
}

// 查询订单
export function checkpay(data) {
  return request({
    url: '/admin/shengya/checkpay',
    method: 'POST',
    data: data || {}
  })
}

// 回传记录
export function toutiao_track(data) {
  return request({
    url: '/admin/shengya/toutiao_track',
    method: 'POST',
    data: data || {}
  })
}

// 测试支付
export function testpay(data) {
  return request({
    url: '/admin/shengya/testpay',
    method: 'POST',
    data: data || {}
  })
}

// 测试支付
export function testpayinfo(data) {
  return request({
    url: '/admin/shengya/testpayinfo',
    method: 'POST',
    data: data || {}
  })
}

// 验证手机哈是否存在（转化营落地页）
export function check_phone(data) {
  return request({
    url: '/admin/shengya/check_phone',
    method: 'POST',
    data: data || {}
  })
}

// 百度统计
export function baidu_track(data) {
  return request({
    url: '/admin/shengya/baidu_track',
    method: 'POST',
    data: data || {}
  })
}

// 广点通统计
export function qq_track(data) {
  return request({
    url: '/admin/shengya/qq_track',
    method: 'POST',
    data: data || {}
  })
}

/**
 * 
 * 老学员成绩单页面
 * 
 * 
 */
// 获取微信用户信息
export function userInfo(data) {
  return request({
    url: '/router/weixin/userInfo',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}
// 老学员成绩单生成海报
export function createPoster(data) {
  return request({
    url: '/router/poster/create',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 事件-统计
export function evenAdd(data){
  return request({
    url: '/router/event/add',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

/*
 *@param: 
 *@return: 
 *@Description: 梦想闹钟
 *@MethodAuthor:  Zhang Xiao Guang
 *@Date: 2020-12-31 11:48:05
*/
// 获取数据
export function activity_storage_getData(data){
  return request({
    url: '/router/activity_storage/getData',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}
// 保存/修改数据
export function activity_storage_setData(data){
  return request({
    url: '/router/activity_storage/setData',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 用户信息
export function userinfo(data) {
  return request({
    url: '/admin/shengya/userinfo',
    method: 'POST',
    data: data || {}
  })
}

// 海报
export function poster_activity816(data){
  return request({
    url: '/poster/activity816',
    method: 'POST',
    domain:'open.xjy.cn',
    data: data || {}
  })
}

// 测评活动
export function ceping_activity_submit(data) {
  return request({
    url: '/admin/ceping/activity_submit',
    method: 'POST',
    data: data || {}
  })
}

// 突破营测评提交手机号验证
export function breakthrough_camp_submit(data) {
  return request({
    url: '/admin/ceping/breakthrough_camp_submit',
    method: 'POST',
    data: data || {}
  })
}

// 知识星球
export function zsxq_submit(data) {
  return request({
    url: '/admin/zsxq/submit',
    method: 'POST',
    data: data || {}
  })
}

export function zsxq_check(data) {
  return request({
    url: '/admin/zsxq/check',
    method: 'POST',
    data: data || {}
  })
}
